// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12mvZ","fullView":"styles_fullView__2EfuW"};